import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as angular from "angular";
import {Endpoints} from "../../shared/config/constant.module";
import HttpServiceName, {HttpService} from "../http/http.service";
let requires = [HttpServiceName];

export interface NavigationPlantsService {
  getPlantNavigation(includeDeleted: boolean): angular.IPromise<apsViewModels.PlantNavigation[]>;
  getLocationNavigation(includeDeleted: boolean): angular.IPromise<apsViewModels.LocationNavigation[]>;
}

class NavigationPlantsSvc implements NavigationPlantsService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  getPlantNavigation(includeDeleted: boolean): angular.IPromise<apsViewModels.PlantNavigation[]> {
    return this.httpService.get(Endpoints.NAVIGATION_PLANTS, {includeDeleted: includeDeleted});
  }

  getLocationNavigation(includeDeleted: boolean): angular.IPromise<apsViewModels.LocationNavigation[]> {
    return this.httpService.get(Endpoints.NAVIGATION_LOCATIONS, {includeDeleted: includeDeleted});
  }

}

export default angular.module('aps.services.navigationPlants', requires)
  .service('navigationPlantsService', NavigationPlantsSvc)
  .name;



// WEBPACK FOOTER //
// ./src/app/services/navigation/navigationPlants.service.ts